import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { getFormattedServiceLevel } from 'flow/utils/servicelevel-utils';

interface Props {
    serviceLevel: number;
    onDurationChanged: (duration: number) => void;
}

const ServiceLevelTitle = ({ serviceLevel, onDurationChanged }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const formattedServiceLevel = getFormattedServiceLevel(
        serviceLevel,
        i18next,
    );

    return (
        <span className="text-bold flex flex-row items-center text-xl text-gray-800">
            {i18next.t('Queue.Statistics.ServiceLevel.Title')}
            {formattedServiceLevel && (
                <>
                    &nbsp;
                    <div
                        className="cursor-pointer rounded-sm bg-gray-200 px-2 py-1 text-xs"
                        onClick={() =>
                            openModal('durationPicker', {
                                serviceLevel,
                                onDurationChanged,
                            })
                        }
                    >
                        {formattedServiceLevel}
                    </div>
                </>
            )}
        </span>
    );
};

export default ServiceLevelTitle;
